const loadedFonts = new Set();
export const loadGoogleFont = (fontFamily) => {
  if (!fontFamily || loadedFonts.has(fontFamily)) return;
  loadedFonts.add(fontFamily);

  const linkId = `font-${fontFamily.replace(/\s+/g, "-")}`;
  if (document.getElementById(linkId)) return;

  const link = document.createElement("link");
  link.id = linkId;
  link.rel = "stylesheet";
  link.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(
    /\s+/g,
    "+"
  )}:wght@300;400;500;600;700&display=swap`;
  document.head.appendChild(link);
};

export const loadFontIfExists = (fontObj) => {
  if (fontObj?.family) {
    loadGoogleFont(fontObj.family);
  }
};
